import { useTantalimMutation, type TantalimMutationResponse } from '../mutation'
import { type AnalyticsAddInput, type AnalyticsAddSuccess } from '@terros/common'

export function useAddAnalytics(): TantalimMutationResponse<AnalyticsAddInput, AnalyticsAddSuccess> {
  return useTantalimMutation<AnalyticsAddInput, AnalyticsAddSuccess>({
    url: '/analytics/add',
  })
}
